import {
  Box, TableCell, TableRow, Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MATCH_FLOWS_TABLE_HEADER_COLUMNS } from '../consts';
import STRING_KEYS from '../../../../../language/keys';
import { WoodNoResult } from '../../../../../icons/wood-no-result';
import { style } from './style';

export const MatchFlowLogsNoResults = ():JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <TableRow sx={ style.TableRow.sx }>
      <TableCell
        style={ style.TableCol.sx }
        colSpan={ MATCH_FLOWS_TABLE_HEADER_COLUMNS }
      >
        <Box sx={ style.box.sx } >
          <WoodNoResult />
        </Box>
        <Typography variant="h6"
          sx={ style.typography.sx }
          fontWeight={ style.typography.fontWeight }
        >
          {translate(STRING_KEYS.NO_LOGS_NO_WORRIES)}
        </Typography>
        <Typography variant="body2" sx={ style.typography.sx }>
          {translate(STRING_KEYS.NO_MUTCH_HAPPENING_HERE)}
        </Typography>
      </TableCell>
    </TableRow>
  );
};
